/* src/app/shared/back-button/back-button.component.scss */
:host {
  display: block;
}
.back-button {
  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  margin: 0 0 20px 0;
  padding: 8px 18px 6px 14px;
  text-align: left;
  border: 1px solid #FFF;
  border-radius: 20px;
  background: transparent;
  color: #FFF;
  font-family: "Campton-Bold";
  font-size: 14px;
  font-weight: 700;
  line-height: normal;
}
.back-button:hover {
  cursor: pointer;
  border-color: #C4C4C4;
  color: #C4C4C4;
}
.back-button:hover svg {
  fill: #C4C4C4;
}
.back-button svg {
  width: 14px;
  height: 14px;
  fill: #FFF;
}
/*# sourceMappingURL=back-button.component.css.map */
